export const physicsCalculators = [
  {
    name: "حاسبة زمن الوصول",
    link: "/calculator/ar/arrivaltime/",
    description:
      "حاسبة زمن الوصول تقوم بحساب زمن وصول شخص أو سيارة أو جسم متحرك بناءً على السرعة والمسافة.",
    showMain: true,
  },
  {
    name: "حاسبة المتر المكعب",
    link: "/calculator/ar/cubicmeter/",
    description:
      "تقوم هذه الحاسبة بحساب المتر المكعب - حاسبة المتر المكعب الالكترونية - تعلم كيفية حساب المتر المكعب ",
    showMain: true,
  },
  {
    name: "حاسبة قوة عدسة العين",
    link: "/calculator/ar/lenspower/",
    description:
      "تقوم حاسبة قوة العدسة الالكترونية بحساب عدة العين وقوتها البصيرية بدقة كبيرة وبسرعة عالية",
  },
  {
    name: "حاسبة الشحنة الكهربائية",
    link: "/calculator/ar/electric-charge/",
    description:
      "حاسبة الشحنة الكهربائية تقوم بحساب قيمة الشحنة الكهربائية بناءً على القوة المتبادلة بين جسمين مشحونين.",
    showMain: true,
  },
  {
    name: "حاسبة السرعة - كيفية حساب السرعة",
    link: "/calculator/ar/velocity/",
    description: "حاسبة السرعة تقوم بحساب السرعة بناءً على المسافة والزمن",
    showMain: true,
  },
  {
    name: "حاسبة التسارع - كيفية حساب التسارع",
    link: "/calculator/ar/acceleration/",
    description:
      "حاسبة التسارع تقوم بحساب التسارع بناءً على التغير في السرعة والزمن.",
  },
  {
    name: "حاسبة طاقة الفوتون",
    link: "/calculator/ar/photonenergy/",
    description:
      "حاسبة طاقة الفوتون تقوم بحساب طاقة الفوتون بناءً على تردد الفوتون وثابت بلانك.",
  },
  {
    name: "حاسبة قوة الاحتكاك",
    link: "/calculator/ar/frictionforce/",
    description:
      "حاسبة قوة الاحتكاك تقوم بحساب قوة الاحتكاك بناءً على التسارع والكتلة.",
  },
  {
    name: "حاسبة قوة محرك السيارة",
    link: "/calculator/ar/horsepower/",
    description:
      "حاسبة قوة محرك السيارة تقوم بتقدير القدرة الحصانية لمحرك السيارة بناءً على وزن السيارة والوقت المنقضي والسرعة المستخدمة لإنهاء مسافة ربع ميل. ",
  },
  {
    name: "حاسبة طاقة الحركة",
    link: "/calculator/ar/kineticenergy/",
    description:
      "حاسبة طاقة الحركة تقوم بحساب طاقة حركة جسم بناءً على الكتلة والسرعة.",
  },
  {
    name: "حاسبة الطاقة الكامنة ",
    link: "/calculator/ar/potentialenergy/",
    description:
      "حاسبة الطاقة الكامنة الشامل: قم بحساب الطاقة الكامنة، الكتلة، أو الارتفاع بناءً على القيم المدخلة للكتلة، الارتفاع، أو الطاقة الكامنة. أداة دقيقة وسهلة الاستخدام.",
  },
  {
    name: "حاسبة الطاقة الكهربائية ",
    link: "/calculator/ar/electricalenergy/",
    description:
      "حاسبة الطاقة الكهربائية الشامل: قم بحساب الطاقة الكهربائية، القدرة، أو الوقت بناءً على القيم المدخلة للقدرة، أو الوقت، أو الطاقة الكهربائية. أداة دقيقة وسهلة الاستخدام.",
    showMain: true,
  },
  {
    name: "حاسبة قانون أوم ",
    link: "/calculator/ar/ohmslaw/",
    description:
      "حاسبة قانون أوم الشاملة: احسب الجهد، التيار، أو المقاومة باستخدام القيم المدخلة للجهد، أو التيار، أو المقاومة. أداة دقيقة وسهلة الاستخدام.",
    showMain: true,
  },
  {
    name: "حاسبة الموجة ",
    link: "/calculator/ar/wave/",
    description:
      "حاسبة الموجة الشاملة: احسب الطول الموجي، التردد، أو سرعة الموجة باستخدام القيم المدخلة. أداة دقيقة وسهلة الاستخدام.",
    showMain: true,
  },
  {
    name: "حاسبة الضغط ",
    link: "/calculator/ar/pressure/",
    description:
      "حاسبة الضغط الشاملة: احسب الضغط، القوة، أو المساحة باستخدام القيم المدخلة. أداة دقيقة وسهلة الاستخدام.",
  },
  {
    name: "حاسبة المقاومة ",
    link: "/calculator/ar/resistor-calculator/",
    description:
      "تساعدك هذه الحاسبة على معرفة قيمة المقاومة بناءً على ألوانها.",
  },
  {
    name: "حاسبة كتلة الأرض",
    link: "/calculator/ar/earth-mass-calculator/",
    description: "احسب كتلة الأرض باستخدام قانون الجذب العام.",
  },
  {
    name: "اختيار العدد المناسب من الألواح الشمسية والبطارية والانفرتر",
    link: "/calculator/ar/solar-calculator/",
    description:
      "احسب نظام الطاقة الشمسية الخاص بك لمنزلك باستخدام هذه الحاسبة.",
  },
  {
    name: "حاسبة كثافة الماء",
    link: "/calculator/ar/water-density-calculator/",
    description:
      "استخدم حاسبة كثافة الماء لحساب كثافة الماء أو أي مادة أخرى بسهولة باستخدام المعادلة: الكثافة = كتلة المادة / حجم المادة. تعلم كيفية تحويل وحدات الكثافة وفهم مفهوم الكثافة.",
  },
  {
    name: "حاسبة قدرة المحول",
    link: "/calculator/ar/transformer-capacity-calculator/",
    description:
      "استخدم حاسبة قدرة المحول لحساب قدرة المحول الكهربائي لأي منشأة بسهولة ودقة. أدخل الجهد وشدة التيار للحصول على القدرة المطلوبة باستخدام الصيغة المناسبة.",
  },
];
export default physicsCalculators;